import styled, { css } from "styled-components";
const TableHeaderCell = styled.th(
  ({ $isNumeric, $borderedHeader, $noMinWidth, theme }) => css`
    && {
      background-color: ${theme.colors.table.head.background};
      ${$noMinWidth ? "" : "min-width: 50px;"}
      border: ${$borderedHeader ? `1px solid ${theme.colors.table.row.divider}` : "0"};
      border-top: 0;
      padding: 0 5px;
      vertical-align: middle;
      white-space: nowrap;
      font-weight: normal;
      font-size: ${theme.fonts.size.small};
      ${$isNumeric ? "text-align: right" : ""}
    }
  `
);
export default TableHeaderCell;
